/**
 * List Schema of PosicaoMotorista
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {PosicaoMotorista} from '@/model/resource/PosicaoMotorista'

/* TODO: review generated schema */
export class ListPosicaoMotoristaSchema extends Schema {
  readonly name = 'ListPosicaoMotorista'

  readonly fieldSet: FieldSet<PosicaoMotorista> = {
    idPosicaoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    latitude: (): FieldComponent => ({
      is: Component.Render,
    }),
    longitude: (): FieldComponent => ({
      is: Component.Render,
    }),
    data: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.data),
      },
    }),
    distanciaParaDestinoEmMetros: (): FieldComponent => ({
      is: Component.Render,
    }),
    duracaoParaDestinoEmSegundos: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
